import { type APIResponse, get } from './base-fetch';

export type TeamRelatedProject =
  APIResponse<'/api/v4/teams/{teamId}/related-projects'>[number];

export const fetchTeamRelatedProjects = (teamId: string) =>
  get<TeamRelatedProject[]>(`/v4/teams/${teamId}/related-projects`);
